import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AppHeader from "@/components/AppHeader";
import MobileNav from "@/components/MobileNav";
import BetSlipCard from "@/components/BetSlipCard";
import api from "@/lib/api";
import { toast } from "sonner";

export default function HistoryPage() {
  const [slips, setSlips] = useState([]);
  const nav = useNavigate();
  useEffect(() => { api.get("/slips").then(r => setSlips(r.data)).catch(() => toast.error("Failed")); }, []);
  return (
    <div className="min-h-screen bg-[#0A0D14] pb-24 md:pb-8">
      <AppHeader />
      <MobileNav />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-6">
        <h1 className="text-3xl sm:text-4xl font-black uppercase tracking-tight text-white mb-6" style={{ fontFamily: "Barlow Condensed, sans-serif" }}>
          Slip History
        </h1>
        {slips.length === 0 ? (
          <div className="text-slate-500 text-sm">Nothing here yet.</div>
        ) : (
          <div className="grid gap-4 md:grid-cols-2">
            {slips.map(s => <BetSlipCard key={s.slip_id} slip={s} onOpen={() => nav(`/slip/${s.slip_id}`)} />)}
          </div>
        )}
      </main>
    </div>
  );
}
